<template>
  <v-textarea
    v-model="form.add_info"
    rows="2"
    :counter="1500"
    :readonly="readonly"
    :error-messages="errors.get('add_info')"
    :rules="getRulesByName('add_info')"
    @input="updateValue('add_info', $event)"
  />
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { maxLength, notEmoji } from '@/modules/_global/variables/rules';

export default {
  name: 'AdditionalInfoForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        add_info: ''
      },
      rules: {
        add_info: [maxLength(1500), notEmoji]
      }
    };
  }
};
</script>
